//@flow
export const logoSource = require("./logo/usz@3x.png");